var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-input el-input--mini",class:_vm.disableClass},[_c('money',_vm._b({staticClass:"el-input__inner",attrs:{"disabled":_vm.inputModel.disabled},model:{value:(_vm.inputModel.value),callback:function ($$v) {_vm.$set(_vm.inputModel, "value", $$v)},expression:"inputModel.value"}},'money',_vm.moneyConfig,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }